/*
*   File : loader.js
*   Author : https://evoqins.com
*   Description :  Loader component
*   Integrations : NA
*   Version : 1.0.0
*/

import { memo } from "react";

// Assets 
import LoaderImg from "../../Assets/Images/app-loader.gif";

function Loader(props) {
    return (
        <div className={`${props.wrapperClassName} mx-auto text-center`}>
            <img src={LoaderImg}
                draggable="false"
                className="h-48"
                alt='loader' />
        </div>
    )
}

export default memo(Loader);